<template>
    <html>
    <body style="position: relative;background: #fff">
        <!--banner-->
        <!-- <div class="nding">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/zhihui/zhihui">智慧农业</a>&gt; <a href="">农产品溯源系统</a>
            </div>
        </div> -->
        <!--...bannner...-->
        <div class="banner">
            <img src="@/assets/styles/picture/banner05.png" alt="" style="width: 100%;">
        </div>
        <!--...miaoshu...-->
        <!--<div class="miaoshu">
            <img src="@/assets/styles/picture/miaoshu.png" />
        </div>-->
        <div class="miaoshu">
            <div class="miaoshu_box">
                <h3 class="title">
                    系统描述
                </h3>
                <p class="title_e">
                    SYSTEM INTRODUCTION
                </p>
                <p class="miaoshu_con">
                    农产品质量监管及溯源系统是在现行农业标准化生产的基础上，建立生产者、批发商、消费者和监管者“四位一体”
                    的共享平台；包括农产品质量安全溯源系统（种植业、养殖业）、农产品质量安全监管系统等，达到“生产过程可监督、
                    农业投入品可管控、质量安全可监管、产品责任可追溯、优质产品可查询”的目标、从而全方位发挥监督、鼓励、鞭策
                    和推动作用，建立质量安全监管机制、创建现代农业管理新模式。
                </p>
                <img src="@/assets/styles/picture/miaoshu01.png" />
            </div>
        </div>
        <!--...fuwu...-->
        <div class="fuwu">
            <div class="fuwu_box">
                <h3 class="title">
                    服务用户
                </h3>
                <p class="title_e">
                    SERVICE UESR
                </p>
                <div class="sort_all">
                    <div class="sort_fuwu sort01">
                        <div class="sort_img">
                            <img src="@/assets/styles/picture/icon01.png" />
                        </div>
                        <div class="sort_font">
                            <p>
                                政府管理者
                            </p>
                        </div>
                        <!--..划过层..-->
                        <div class="sort_h">
                            <p>
                                对内：实时查看，分析农业基础生产、农产品溯源、销售、监控等数据，适时做出正确客观的决策；
                            </p>
                            <p>
                                对外：面向公众推出真实、权威的农特产品溯源信息，对责任主体提供农产品认证及合格证的申请服务；
                            </p>
                        </div>
                    </div>
                    <div class="sort_fuwu sort02">
                        <div class="sort_img">
                            <img src="@/assets/styles/picture/icon02.png" />
                        </div>
                        <div class="sort_font">
                            <p>
                                涉农企业
                            </p>
                        </div>
                        <!--..划过层..-->
                        <div class="sort_h">
                            <p>
                                完成农产品生产数据的采集、移动采集及生产管理、质量检测、经营管理等数据，并实时监控生产情况；
                            </p>
                        </div>
                    </div>
                    <div class="sort_fuwu sort03">
                        <div class="sort_img">
                            <img src="@/assets/styles/picture/icon03.png" />
                        </div>
                        <div class="sort_font">
                            <p>
                                消费者
                            </p>
                        </div>
                        <!--..划过层..-->
                        <div class="sort_h">
                            <p>
                                获取农特产品溯源信息及市场行情，查询、购买“三品一标”农特产品或具有合格证的农特产品并逐渐树立农特产品质量安全监督意识；
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--...jishu...-->
        <div class="jishu">
            <div class="liucheng_box">
                <h3 class="title">
                    追溯技术
                </h3>
                <p class="title_e">
                    TRACEBILITY TECHNOLOGY
                </p>
            </div>
            <img src="@/assets/styles/picture/jishu01.png" />
        </div>
        <!--...liucheng...-->
        <div class="liucheng">
            <div class="liucheng_box">
                <h3 class="title">
                    业务流程
                </h3>
                <p class="title_e">
                    BUSINESS PROCESS
                </p>
                <div class="sort_all liucheng_con">
                    <div class="plant">
                        <h4>
                            种植业
                        </h4>
                        <p>
                            种植业农产品质量安全监管及溯源系统是通过信息化手段， 对产品质量进行”数字化“管理并建立”身份证“制度， 从而帮助消费者实现”知根溯源“，完成放心消费 。
                        </p>
                        <div class="liucheng_pig">
                            <img src="@/assets/styles/picture/liucheng03.jpg" />
                        </div>
                    </div>
                    <!--<div class="animal">
                            <div class="liucheng_pig">
                                <img src="@/assets/styles/picture/liucheng02.png"/>
                                <img class="liucheng_h2" src="@/assets/styles/picture/animal01.png"/>
                            </div>
                            <p>畜产品质量安全溯源系统是综合应用信息技术和条码技术，
                                实现个体标识和条码标签便捷转换，记录全程各环节信息，
                                实现畜产品自上而下的跟踪和自下向上的追溯。</p>
                            <h4>养殖业</h4>
                        </div>-->
                    <img class="liucheng_h1" src="@/assets/styles/picture/plant01.png" />
                </div>
            </div>
        </div>
        <!--...tedian...-->
        <div class="tedian">
            <div class="liucheng_box">
                <h3 class="title">
                    系统特点
                </h3>
                <p class="title_e">
                    SYSTEM FEATURES
                </p>
            </div>
            <img src="@/assets/styles/picture/tedian01.png" />
        </div>
        <!--...fangan...-->
        <div class="fangan">
            <h3 class="title">
                行业解决方案
            </h3>
            <p class="title_e">
                TOTAL SOLUTION
            </p>
            <div class="fangan_box sort_all">
                <div class="fangan_sort">
                    <img src="@/assets/styles/picture/fangan01.png" />
                    <div class="fangan_font">
                        <h4>
                            种植追溯系统
                        </h4>
                        <p>
                            建立农产品“身份证”制度，对农产品质量安全进行数字化管理
                        </p>

                    </div>
                </div>
                <div class="fangan_sort">
                    <img src="@/assets/styles/picture/fangan02.png" />
                    <div class="fangan_font">
                        <h4>
                            养殖追溯系统
                        </h4>
                        <p>
                            全程监管畜产品安全生产的信息链、物流链和控制链，实现放心消费
                        </p>
                    </div>
                </div>
                <div class="fangan_sort">
                    <img src="@/assets/styles/picture/fangan03.png" />
                    <div class="fangan_font">
                        <h4>
                            林业追溯系统
                        </h4>
                        <p>
                            信息可视化、扫码查询种植、加工、检测等溯源信息，提成产品质量信誉度
                        </p>
                    </div>
                </div>
                <div class="fangan_sort">
                    <img src="@/assets/styles/picture/fangan04.png" />
                    <div class="fangan_font">
                        <h4>
                            水产追溯系统
                        </h4>
                        <p>
                            实时检测动物健康指数，成长周期，全方位把控水产品质量安全
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!--...anli...-->
        <div class="anli">
            <div class="liucheng_box">
                <h3 class="title">
                    成功案例
                </h3>
                <p class="title_e">
                    success case
                </p>
            </div>
            <img src="@/assets/styles/picture/anli01.png" />
        </div>
    </body>
</html>
</template>

<script>
    import '@/assets/styles/css/zhihui.css';   
    export default {
        title: '12321',
        components: {},
        data: () => {
            return {

            };
        },
        created() {
            let wintitle = `${window.document.title}`;
            let title = wintitle.split('-')
            window.document.title = '农产品质量安全溯源系统 - ' + title[1];
        },

        methods: {

        },
    }
</script>
